import { Component, OnInit, ElementRef, AfterViewInit, ChangeDetectorRef, SimpleChange, Input, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalValidators } from '../../utils/utils';
import { environment } from './../../../environments/environment';
import { AccountService } from './../../services/services.module';
import { SocialAuthService, SocialUser, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { TranslateService } from '@ngx-translate/core';
import { GlobalConfig } from '../../shared/global-config';
import { MatDialog } from '@angular/material/dialog';
import { getEncripted } from '../../utils/pw-encripted';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() iposignUp;
  testError: any;
  testVal;
  renderer: any;
  automationEnvirement: any;
  signinForm: FormGroup;
  registrationForm: FormGroup;
  socialLoginRegistrationForm: FormGroup;
  signinFormErrors;
  captchaVaidation;
  startRegistraionShowNIC = false;
  showSignupForm = false;
  verificationSent = false;
  showSocialLoginRegistration = false;
  isSocialLogin: boolean;
  signUpFormErrors = false;
  changePWType = false;
  showRecaptcha = false;
  showRecaptchaOnRegi = false;
  resetOnError = false;
  siginingInProgress;
  residentSelectData = ['NIC', 'Passport', 'BRN'];
  requestCaptchaKey: any;
  enableCaptcha = false;
  captchaAttempts = 1;

  selected: string = 'login';

  socialUser: SocialUser;
  private loggedIn: boolean;
  suggestedId: any;
  eventId: any;
  profileId;
  checkuserAvailability: boolean;
  userAvailability: any;
  globalConfig = GlobalConfig.countryCode;
  mfaPageActive;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private accountservice: AccountService,
    private socialAuthService: SocialAuthService,
    private el: ElementRef,
    private cdRef: ChangeDetectorRef,
    public translate: TranslateService,
    private dialogRef: MatDialog
  ) {
    this.accountservice.getSavedId.subscribe(async (savedId) => {
      if (savedId) {
        this.suggestedId = Object.keys(savedId).includes('activities') ? savedId['activities']['id'] : null;
        this.profileId = Object.keys(savedId).includes('profile') ? savedId['profile'] : null;
        this.eventId = Object.keys(savedId).includes('eventId') ? savedId['eventId']['eventId'] : null;
      }
    });
  }
  ngAfterViewInit() {
    if (this.el.nativeElement.querySelector('.us')) {
      this.el.nativeElement.querySelector('.us').setAttribute('contenteditable', 'true');
      this.el.nativeElement.querySelector('.us').focus();
    }
  }
  async ngOnInit() {
    this.dialogRef.closeAll();
    if (GlobalConfig.countryCode === 'bn') {
      this.residentSelectData = ['NIC', 'Passport'];
    }
    if (this.router.url.indexOf('signup') > -1) {
      this.registrationProcess();
    }
    localStorage.clear();
    localStorage.setItem('lang', JSON.stringify({ lang: 'English', value: 'en' }));
    this.translate.use('en');

    this.socialAuthService.authState.subscribe((user) => {
      if (this.isSocialLogin) {
        this.socialUser = user;
        this.isSocialLogin = false;
        this.socialSignIn();
      }
    });

    if (this.router.url.indexOf('registration') >= 0) {
      this.registrationProcess();
    }
    this.bindSigninForm();
    this.bindRegistrationForm();
    this.bindSocialLoginRegistrationForm();
    // console.log(this.el.nativeElement);

    this.accountservice.signOut();
    this.signinForm.valueChanges.subscribe((val) => {
      this.signinFormErrors = undefined;
    });
  }
  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (changes['iposignUp']) {
      if (this.iposignUp) {
        this.registrationProcess();
      } else {
        this.BackToSignupProcess();
      }
    }
  }
  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData || null;
    let pastedText = clipboardData.getData('text');
    // console.log(pastedText);
    const regex = new RegExp('^[a-zA-Z0-9~@+.]+$');
    // const key = String.fromChaevent.charCoderCode(! ? event.which : event.charCode);

    if (!regex.test(pastedText)) {
      event.preventDefault();
      return false;
    }
  }
  restrictUN(event) {
    const regex = new RegExp('^[a-zA-Z0-9~@+.]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);

    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }
  restrict(event) {
    const regex = new RegExp('^[a-zA-Z0-9~]+$');
    const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);

    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }
  bindSigninForm() {
    let testUsername, testPassword;

    if (environment.dev) {
      testUsername = 'digital@cal.lk';
      testPassword = 'Test@123';
      this.showRecaptcha = true;
    }
    // (environment.dev && GlobalValidators.noop) ||
    this.signinForm = this.fb.group({
      username: [testUsername, [Validators.required]],
      password: [testPassword, Validators.required],
      rememberMe: [false],
      captchaResponse: [],
      captchaText: [, GlobalValidators.requireIfAttemptsExceed(this.enableCaptcha)],
      captchaAttempts: [1],
    });

    this.signinForm.valueChanges.subscribe((value) => {
      this.showRecaptcha = true;
      this.signinFormErrors = undefined;
    });
  }

  bindRegistrationForm() {
    this.registrationForm = this.fb.group({
      resident: ['NIC'],
      nic: [
        '',
        [
          GlobalValidators.requireIf('resident', (c) => c.value === 'NIC'),
          GlobalConfig.countryCode === 'bn' ? GlobalValidators.nicBn : GlobalValidators.nic,
        ], // (environment.dev && GlobalValidators.noop) ||
      ],
      passport: ['', [GlobalValidators.requireIf('resident', (c) => c.value === 'Passport'), GlobalValidators.passport]],
      brn: ['', [GlobalValidators.requireIf('resident', (c) => c.value === 'BRN')]],
    });
    this.registrationForm.get('resident').valueChanges.subscribe((value) => {
      if (value === 'NIC') {
        this.registrationForm.get('passport').setValue('', { emitEvent: true });
        this.registrationForm.get('brn').setValue('', { emitEvent: true });
      } else if (value === 'Passport') {
        this.registrationForm.get('nic').setValue('', { emitEvent: false });
        this.registrationForm.get('brn').setValue('', { emitEvent: true });
      } else {
        this.registrationForm.get('nic').setValue('', { emitEvent: false });
        this.registrationForm.get('passport').setValue('', { emitEvent: true });
      }
      this.signUpFormErrors = false;
    });
    this.registrationForm.valueChanges.subscribe((val) => {
      this.userAvailability = false;
    });
    this.registrationForm.get('passport').valueChanges.subscribe((value) => {
      if (!!value) {
        this.showRecaptchaOnRegi = true;
        if (value.indexOf(' ') >= 0) {
          this.registrationForm.get('passport').setValue(value.trim());
        }
      }
    });
    this.registrationForm.get('nic').valueChanges.subscribe((value) => {
      if (!!value) {
        this.showRecaptchaOnRegi = true;

        if (value.indexOf(' ') >= 0) {
          this.registrationForm.get('nic').setValue(value.trim());
        }
      }
    });
  }

  bindSocialLoginRegistrationForm() {
    this.socialLoginRegistrationForm = this.fb.group({});
  }

  registrationProcess() {
    // this.startRegistraionShowNIC = true;
    this.showSignupForm = true;
  }

  BackToSignupProcess() {
    this.socialUser = null;
    if (this.router.url.indexOf('registration') >= 0) {
      this.router.navigate(['/signin']);
    } else {
      this.startRegistraionShowNIC = false;
      this.signUpFormErrors = false;
      this.showSocialLoginRegistration = false;
    }

    // if (this.socialAuthService) {
    //   this.socialAuthService.signOut();
    //   console.log('Sign Out Social Login - Back Button');
    // }
    setTimeout(() => {
      if (this.el.nativeElement.querySelector('.us')) {
        this.el.nativeElement.querySelector('.us').setAttribute('contenteditable', 'true');
        this.el.nativeElement.querySelector('.us').focus();
      }
    }, 100);
  }

  mfaValidationStatus(event) {
    if (event === 'success') {
      this.getNavigatorInfo();

      this.gotoDashboard();

    } else if (event === 'fail') {
      this.mfaPageActive = false;
      // this.bindSigninForm();
      this.cdRef.detectChanges();
    }
  }
  async registration(form) {
    if (form.invalid) {
      this.signUpFormErrors = true;
      return;
    }
    try {
      this.checkuserAvailability = true;

      this.userAvailability = await this.checkUser(
        (this.registrationForm.get('nic').value && this.registrationForm.get('nic').value) || this.registrationForm.get('passport').value,
        form.value.resident
      );

      this.checkuserAvailability = false;
    } catch (e) {
      this.checkuserAvailability = false;
    }

    this.showSignupForm = !this.userAvailability;
    this.cdRef.detectChanges();
  }

  socialLoginRegistration(form) {
    this.showSocialLoginRegistration = false;
    this.startRegistraionShowNIC = true;
    this.showSignupForm = false;
    this.verificationSent = false;
    this.cdRef.detectChanges();
  }

  // submitSignInCaptcha(captchaResponse: string) {
  //   this.signinForm.get('captchaResponse').setValue(captchaResponse);
  // }

  onSignin(form) {
    if (form.invalid) {
      return;
    }

    this.resetOnError = false;
    this.siginingInProgress = true;
    this.signinFormErrors = undefined;
    this.signinForm
      .get('captchaResponse')
      .setValue(this.requestCaptchaKey + ',' + (this.signinForm.get('captchaText').value || '').toLowerCase());
    this.signinForm.get('captchaAttempts').setValue(this.captchaAttempts);

    // Encrypt password before sending
    const encryptedPassword = getEncripted(form.value.password);
    const signInData = {
      ...form.value,
      password: encryptedPassword
    };

    this.accountservice
      .signIn(signInData)
      .then((data) => {
        this.siginingInProgress = false;
        this.mfaPageActive = true;
        // this.mfaValidationStatus('success');
        this.cdRef.detectChanges();
      })
      .catch((e) => {
        this.captchaAttempts += 1;
        if (this.captchaAttempts > 2) {
          this.enableCaptcha = true;
        }

        this.resetOnError = true;
        const userName = this.signinForm.get('username').value;
        const password = this.signinForm.get('password').value;

        form.resetForm();
        this.bindSigninForm();
        this.signinForm.get('username').setValue(userName);
        this.signinForm.get('password').setValue(password);
        if (e.status >= 400 && e.status < 500) {
          // console.log(e);
          if (!!e && !!e.message && e.message.indexOf('CAPTCHA') >= 0) {
            this.signinFormErrors = 'The CAPTCHA wasn&rsquo;t entered correctly. Try it again';
          } else if (!!e && !!e.error_description && e.error_description.indexOf('locked') >= 0) {
            this.signinFormErrors = e.error_description;
          } else if (!!e && e.error.userBlocked && e.error.userBlocked === 'true') {
            this.signinFormErrors = `Your account has been blocked. Please use the "<a href="/forgot-password">Forgot Password</a>" feature to unlock`;
          } else {
            this.signinFormErrors = 'Invalid Email or Password';
          }
        } else {
          this.signinFormErrors = 'Network error occurred. Please Try Again.';
        }
        this.siginingInProgress = false;
        this.cdRef.detectChanges();
      });
  }

  changeNIC(event) {
    this.showSignupForm = false;
    this.verificationSent = false;
  }

  captchaRequest(event) {
    this.requestCaptchaKey = event.key;
    this.automationEnvirement = event.required;
  }

  displayPassword() {
    this.changePWType = !this.changePWType;
  }

  backToLogin(event) {
    this.socialUser = null;
    this.showSignupForm = false;
    this.verificationSent = false;
    this.startRegistraionShowNIC = false;
    this.registrationForm.reset();
    this.registrationForm.get('resident').setValue('NIC', { emitEvent: false });
  }

  signInWithGoogle() {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
    this.isSocialLogin = true;
  }

  // signInWithFB() {
  //   this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
  //   this.isSocialLogin = true;
  // }

  // signInWithLinkedIn() {
  //   this.socialAuthService.signIn(LinkedInLoginProvider.PROVIDER_ID);
  //   this.isSocialLogin = true;
  // }

  signOutSocial() {
    if (this.socialAuthService) {
      this.socialAuthService.signOut();
      // console.log('Sign Out Social Login - Subscribe User');
    }
    this.isSocialLogin = false;
  }

  socialSignIn() {
    this.loggedIn = this.socialUser != null;

    if (this.loggedIn && this.socialUser) {
      if (this.socialUser.provider === 'FACEBOOK' || this.socialUser.provider === 'GOOGLE' || this.socialUser.provider === 'LINKEDIN') {
        this.accountservice
          .socialSignIn({ provider: this.socialUser.provider, token: this.socialUser.authToken })
          .then((data) => {
            this.siginingInProgress = false;
            this.router.navigate(['/']);
          })
          .catch((e) => {
            if (e.status >= 400 && e.status < 500) {
              if (!!e.json() && !!e.json().errorCode && e.json().errorCode.indexOf('8') >= 0) {
                this.showSocialLoginRegistration = true;
                this.startRegistraionShowNIC = false;
                this.showSignupForm = false;
                this.verificationSent = false;
              }
            }
          });
      } else {
        this.signOutSocial();
      }
    }
  }

  async checkUser(userId, type) {
    let { isExistingUser } = await this.accountservice.isAvailableUser(userId, type);
    return isExistingUser;
  }

  async gotoDashboard() {
    let currentUser = await this.accountservice.currentUserAsync();
    if (this.router.url.indexOf('ipo') > -1 || this.router.url.indexOf('debenture-issue') > -1) {
      this.accountservice.emitLoginStatus(true);
    } else {
      this.router.navigate([`/dashboard`], { queryParams: { uid: `${currentUser.id}` } });
    }
  }
  async getNavigatorInfo() {
    // console.log(navigator);
    let browserInfo = {
      appCodeName: navigator['appCodeName'],
      appName: navigator.appName,
      appVersion: navigator.appVersion,
      platform: navigator.platform,
      userAgent: navigator.userAgent,
      vendor: navigator.vendor,
    };
    try {
      await this.accountservice.saveBrowserInfo(browserInfo);
    } catch (e) { }
  }
}
